/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import $ from 'jquery';
//import moment from 'moment';
//import 'moment-timezone';
import timezones from './timezones';
import {
//  findValue,
  generateElement,
} from './utils/Utils';
import Plugin from './utils/Plugin';
import './styles/styles.css';

export default class TimezonePicker extends Component {
  constructor(props) {
    super(props);
    this.$el = null;
    this.state = {
      //isDrawMap: props.isDrawMap,
      selectedTime: props.selectedTime,
      //options: {},
    };
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    const { isDrawMap } = this.props;
    const self = this;
    if (this.timezonemap) {
      this.$el = $(this.timezonemap);
      this.setDefaultValue();
    }

    if (isDrawMap) {
      this.generateMap();
    }

    this.$el.on('mouseenter', 'svg polygon', (e) => {
      const data = $(e.target).data();
      const { hoverText } = this.props;
      this.$el.find('.hover-text p').addClass('active').text(hoverText && hoverText instanceof Function ? hoverText(e, data) : (`${data.timezone} (${data.zonename})`));
    });
    this.$el.on('mouseleave', 'svg polygon', () => {
      $(self.refs.timezonemap).find('.hover-text p').removeClass('active').text('');
    });
    this.$el.on('click', 'svg polygon', (e) => {
      const $this = $(this);
      self.setValue($(e.target).data('offset'), $(e.target).data('timezone'));
      $this.trigger('map:country:clicked');
    });
  }

  componentDidUpdate(prevProps) {
    const { selectedTime } = this.props;

    if (selectedTime && selectedTime.name !== prevProps.selectedTime.name && selectedTime.id !== '' && selectedTime.id !== 'searching') {
      this.setState({
        selectedTime,
      }, () => {
        this.setDefaultValue(selectedTime);
      });
    }
  }

  componentWillUnmount() {
  }

  setDefaultValue(obj) {
    if (typeof obj === 'undefined') {
      const { selectedTime } = this.state;
      const findOffset = timezones.filter((item) => {
        return item.timezone.indexOf(selectedTime.zone) > -1;
      });
      const defaultOffset = findOffset[0].offset;
      const defaultTimezone = findOffset[0].timezone;

      this.setValue(defaultOffset, defaultTimezone, 'defaultValue');
    } else {
      const selectedZone = obj.zone;
      const findOffset = timezones.filter((item) => {
        return item.timezone.indexOf(selectedZone) > -1;
      });

      if (findOffset.length === 0) {
        return null;
      }

      const defaultOffset = findOffset[0].offset;
      const defaultTimezone = findOffset[0].timezone;

      this.setValue(defaultOffset, defaultTimezone, 'defaultValue');
    }
  }

  setValue(value, zonename, string) {
    if (typeof string !== 'undefined') {
      this.$el.find('svg polygon').attr('data-selected', 'false');
      const elements = this.$el.find(`svg polygon[data-offset="${value}"]`);
      if (elements && elements.length) {
        elements.attr('data-selected', 'true');
      }

      this.$el.trigger('map:value:changed');
      return;
    }

    const newArray = timezones.filter((item) => {
      return item.offset === value;
    });
    this.$el.find('svg polygon').attr('data-selected', 'false');

    const elements = this.$el.find(`svg polygon[data-offset="${value}"]`);
    if (elements && elements.length) {
      elements.attr('data-selected', 'true');
    }

    this.$el.trigger('map:value:changed');
    this.props.setValue(newArray, zonename);
  }

  generateMap = () => {
    const options = this.props;
    const polygon = [];
    const option = [];
    const containerArr = [];
    const timezone = Object.assign([], timezones);

    Object.keys(timezone).forEach((index) => {
      polygon.push(generateElement({
        element: 'polygon',
        attr: {
          'data-timezone': timezone[index].timezone,
          'data-country': timezone[index].country,
          'data-pin': timezone[index].pin,
          'data-offset': timezone[index].offset,
          points: timezone[index].points,
          'data-zonename': timezone[index].zonename,
        },
        isSvg: true,
      }));

      option.push(generateElement({
        element: 'option',
        attr: {
          value: timezone[index].timezone,
        },
        chilled: `${timezone[index].timezone}(${timezone[index].zonename})`,
      }));
    });

    if (options.showHoverText) {
      const content = generateElement({
        element: 'p',
      });
      const hoverZone = generateElement({
        element: 'div',
        attr: {
          class: (`${options.hoverTextClass} hover-text`).trim(),
        },
        chilled: content,
      });
      if (options.hoverTextEl) {
        options.hoverTextEl.append(hoverZone);
      } else {
        containerArr.push(hoverZone);
      }
    }

    const svg = generateElement({
      element: 'svg',
      attr: {
        class: 'timezone-map',
        viewBox: '0 0 500 250',
      },
      chilled: polygon,
      isSvg: true,
    });

    if (containerArr.length > 0) {
      const container = generateElement({
        element: 'div',
        attr: {
          class: (`${options.filterBoxClass} filter-box`).trim(),
        },
        chilled: containerArr,
      });
      this.timezonemap.appendChild(container);
    }
    this.timezonemap.appendChild(svg);
    this.props.generateMapCallback();
  };

  render() {
    return (
      <div
        className="time-zone-map"
        ref={(ref) => {
          this.timezonemap = ref;
        }}
      />
    );
  }
}
Plugin({ pluginName: 'timezonePicker', ClassRef: TimezonePicker });

TimezonePicker.defaultProps = {
  width: 500,
  height: 250,
  filterBoxClass: '',
  showHoverText: true,
  hoverTextClass: '',
  hoverTextEl: null,
  hoverText: (e, data) => {
    return (`${data.timezone} (${data.zonename})`);
  },
};
